import { render, staticRenderFns } from "./MemberEmailIdChange.vue?vue&type=template&id=55479198"
import script from "./MemberEmailIdChange.vue?vue&type=script&lang=js"
export * from "./MemberEmailIdChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports